import types from './types'
import default_state from '../state'
import enabled_services from '../../enabled_services.js'


export default {
  [types.SET_ANON] (state, item) {
    state['AUTH.anonUser'] = item
  },
  [types.FLIP_COLOR_MODE] (state, item) {
    state['AUTH.colorMode'] = !state['AUTH.colorMode']
  },

  [types.UID_NOT_PRESENT] (state, item) {
    state['AUTH.uidNotPresent'] = item
  },

  [types.SET_MY_CURRENT_CUPPING] (state, item) {
    state['AUTH.myCurrentCupping'] = item
  },

  [types.SET_MY_COFFEES] (state, item) {
    state['AUTH.myCoffees'] = item
  },
  [types.CLEAR_MY_COFFEES] (state, item) {
    state['AUTH.myCoffees'] = {}
  },

  [types.SET_MY_PUBLIC_DATA] (state, item) {
    state['AUTH.myPublicData'] = item
  },
  [types.CLEAR_MY_PUBLIC_DATA] (state, item) {
    state['AUTH.myPublicData'] = {}
  },

  [types.SET_MY_PRIVATE_DATA] (state, item) {
    state['AUTH.myPrivateData'] = item
  },
  [types.CLEAR_MY_PRIVATE_DATA] (state, item) {
    state['AUTH.myPrivateData'] = {}
  },

  [types.SHOW_CUPPING_SETTINGS] (state, item) {
    state['AUTH.showCuppingSettings'] = item
  },
  [types.SHOW_HEADER_SHOP] (state, item) {
    state['AUTH.showHeaderShop'] = item
  },
  [types.SET_LOADED] (state, item) {
    state['AUTH.loaded'] = item
  },
  [types.SET_PROFILE_PIC] (state, item) {
    state['AUTH.profilePic'] = item
  },
  [types.SET_USERNAME] (state, item) {
    state['AUTH.username'] = item
  },
  [types.SET_UID] (state, item) {
    state['AUTH.uid'] = item
  },
  [types.SET_EMAIL] (state, item) {
    state['AUTH.email'] = item
  },
  [types.SET_FRIENDS] (state, item) {
    state['AUTH.friends'] = item
  },
  [types.SET_FRIEND_DATA] (state, item) {
    let data = state['AUTH.friendsDataArray'] || []
    data.push({id: item.friend, data:item.friendData})
    state['AUTH.friendsDataArray'] = data
  },
  [types.SET_DATE_CREATED] (state, item) {
    state['AUTH.accountCreated'] = item
  },
  [types.CLEAR_STATE] (state, item) {
    for (let service in enabled_services) {
      let _state = enabled_services[service].state

      for (let one in _state) {
        state[service + '.' + one] = enabled_services[service].state[one]
      }
    }
  },
  [types.SET_AUTH_ERROR] (state, item) {
    state['AUTH.authError'] = item.message
  },
  [types.CLEAR_AUTH_ERROR] (state, item) {
    state['AUTH.authError'] = false
  },
}


// WEBPACK FOOTER //
// ./src/services/AUTH/mutations/index.js